import { gsap } from "gsap";


const init = () => {

    const menuTrigger = document.querySelectorAll('[data-menu-toggle]');
    const menuSecondaryTrigger = document.querySelectorAll('[class^=toggleMenu-]');
    const menuSecondaryTarget = document.querySelectorAll('[data-menu-target]');
    const body = document.body;

    var menuTl = gsap.timeline({paused: true});
    menuTl
    .to('#main-menu', {pointerEvents: 'all', display: 'block' })
    .from('.main-menu__bg', {bottom: '100%', duration: 0.8, ease: "quad.inOut" }, 0.1)
    .to('#header-main-left .logo path', {fill: '#FAFBFF', duration: 0.2, ease: "quad.inOut" }, 0.1)
    .to('#header-main-left nav', {autoAlpha: 0, duration: 0.2, ease: "quad.inOut" }, 0.1)
    .from('#main-menu #main-menu-big li, #main-menu #menu-main-default li', {autoAlpha: 0, y: '-=50px', duration: 0.4, ease: "quad.out", stagger: 0.05 }, '-=0.6')
    .from('.main-menu__words', {autoAlpha: 0, y: '-=20px', duration: 0.4, stagger: 0.2 }, '-=0.6')
    .from('.main-menu__consulenza, .main-menu__socials-title, .main-menu__socials li, .main-menu__lngs li', {autoAlpha: 0, y: '-=20px', duration: 0.4, ease: "quad.out", stagger: 0.05 }, '-=0.4');
    
    let menuIsOpen = false;

    menuTrigger.forEach((item) => {
        item.addEventListener('click', () => {
            body.classList.toggle('mainMenuIsOpen');

            menuTl.play();

            if(menuIsOpen === true){
                menuTl.reverse();
            }

            menuIsOpen = !menuIsOpen;
        });
    });

    // Help function per selezionare le voci correnti
    document.querySelectorAll('#main-menu-big, #menu-main-default, #menu-main-applicazioni, #menu-main-soluzioni').forEach((menu) => {
        let currentMenuItem = menu.querySelector('.current-menu-item');

        if(currentMenuItem){
            menu.classList.add('hasCurrentMenuItem');
        }
    });

    let appTriggered = false;
    let menuTargetIsHover = false;
    let secondaryOpen = null;

    gsap.set('#main-menu [data-menu-target] ul', { display: 'none' });
    gsap.set('#main-menu [data-menu-target] li', { autoAlpha: 0, y: '-50px' });

    const checkAppMenu = (menuType) => {

        if (appTriggered === true || menuTargetIsHover === true) {

            if (secondaryOpen === null){
                
                const secondaryMenuTlOpen = gsap.timeline({
                    onComplete: () => {
                        secondaryOpen = menuType;
                    }
                });

                secondaryMenuTlOpen.set(`#main-menu #menu-main-${menuType}`, { display: 'block' })
                secondaryMenuTlOpen.to('#main-menu #menu-main-default li', { autoAlpha: 0, y: '+=50px', duration: 0.4, ease: "quad.in", stagger: 0.05 }, 0.1)
                secondaryMenuTlOpen.to(`#main-menu #menu-main-${menuType} li`, { autoAlpha: 1, y: '0px', duration: 0.4, ease: "quad.out", stagger: 0.05 }, '-=0.4');

                body.classList.add('secondaryMenuIsOpen');
                body.classList.add('secondaryMenuIsOpen--' + menuType);
            }

        } else {

            const secondaryMenuTlClose = gsap.timeline({
                onComplete: () => {
                    secondaryOpen = null;
                }
            });

            secondaryMenuTlClose.to(`#main-menu #menu-main-${menuType} li`, { autoAlpha: 0, y: '-50px', duration: 0.4, ease: "quad.in", stagger: 0.05 })
            secondaryMenuTlClose.to('#main-menu #menu-main-default li', { autoAlpha: 1, y: '0px', duration: 0.4, ease: "quad.out", stagger: 0.05 }, '-=0.4')
            secondaryMenuTlClose.set(`#main-menu #menu-main-${menuType}`, { display: 'none' });

            body.classList.remove('secondaryMenuIsOpen');
            body.classList.remove('secondaryMenuIsOpen--' + menuType);

        }
    };

    menuSecondaryTrigger.forEach(item => {
        item.addEventListener('click', () => {

            const menuType = Array.from(item.classList).filter(cl => cl.startsWith('toggleMenu-'))[0].split("-").pop();

            appTriggered = true;
            checkAppMenu(menuType);
        });
    });

    menuSecondaryTrigger.forEach(item => {
        item.addEventListener('mouseleave', () => {

            const menuType = Array.from(item.classList).filter(cl => cl.startsWith('toggleMenu-'))[0].split("-").pop();

            setTimeout(() => {
                appTriggered = false;
                checkAppMenu(menuType);
            }, 500);
        });
    });

    menuSecondaryTarget.forEach(target => {
        target.addEventListener('mouseenter', () => {
            const menuType = target.getAttribute('data-menu-target');

            menuTargetIsHover = true;
            checkAppMenu(menuType);
        });
    });

    menuSecondaryTarget.forEach(target => {
        target.addEventListener('mouseleave', () => {
            setTimeout(() => {
                const menuType = target.getAttribute('data-menu-target');

                menuTargetIsHover = false;
                checkAppMenu(menuType);
            }, 500);
        });
    });
};

export default { init };